import { chowlyApi } from 'config'
import client from '../chowly'
import { LoyaltyDinersResponse } from './models'

export const getLoyaltyDiners = async (
  organizationIds: string | string[],
  page = 1,
  limit = 25
): Promise<LoyaltyDinersResponse> => {
  
  const orgParam = Array.isArray(organizationIds)
    ? organizationIds.join(',')
    : organizationIds

  const params = {
    organization_ids: orgParam,
    ...(page > 1 && { page }),
    ...(limit !== 25 && { limit }),
  }

  const url = chowlyApi.loyaltyDiners
  const { data } = await client.get<LoyaltyDinersResponse>(url, { params })
  return data
}